import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Tooltip } from "antd";
import AddIcon from "../../../../assets/customSVG/AddIcon";
import Download from "../../../../assets/customSVG/campaigns/Download";
import { ICONS } from "../../../../assets/icons";
import useTags from "../../../../hooks/useTags";
import { setFilters } from "../../../../reduxToolkit/crmSlice";
import { crmFontColor, filterKeys, mainFilters, primaryColor } from "../../constants";
import { convertName } from "../../helpers";
import { crmListShow, crmReportStatus, crmReportUserSeen } from "../../api/Api";
import { useAspSelector } from "../../../../../src/test/jest-redux-hooks";
import Modal from "../commonComponents/ParentPositionedModel";
import Button from "../commonComponents/button";
import FilterModelContent from "./mainFilters/FilterModelContent";
import RenderFilters from "./mainFilters/RenderFilters";
import ToastMain from "../../../../components/commonComponents/toast/ToastMain";
import AudienceSetFiltersView from "./AudienceSetFiltersView";

export const MainFilter = ({
  onFilterChange,
  crmCount,
  crmSearch,
  activeFilter,
  selectedItems = [],
  selectAll = false
}) => {
  const [active, setActive] = useState(false);
  const { tagList } = useSelector((store) => store.crm);
  const { currentBrand } = useAspSelector((state) => state.app);
  const [reportStatus, setReportStatus] = useState(true);
  const [operator, setOperator] = useState({
    isModalOpen: false,
    operator: "and",
  }); // and | or.
  const [selectedFilter, setSelectedFilter] = useState({
    filterName: "name",
    field: "",
    fieldValue: "",
  });
  // useState for toast
  const [toastState, setToastState] = useState({
    show: false,
    message: "",
    type: "Success"
  });

  const dispatch = useDispatch();
  const { filters } = useSelector((store) => store.crm);

  useEffect(() => {
    onFilterChange(filters);
  }, [filters, onFilterChange]);

  const selectedTags = useMemo(() => {
    if (selectedFilter.filterName === "tags") {
      if (!Array.isArray(selectedFilter.fieldValue)) return [];
      return selectedFilter.fieldValue.map((item) => item.id);
    }
    return [];
  }, [selectedFilter.fieldValue]);
  const { tags } = useTags(selectedTags);

  function handleClick() {
    setActive(!active);
    setOperator((prev) => {
      return { ...prev, operator: "and" };
    });
  }

  const handleChangeFilter = (item) => {
    if (["dropdown", "tags"].includes(mainFilters[item].props.type)) {
      setSelectedFilter({
        filterName: item,
        field: "",
        fieldValue: [],
        dropdownOpen: null,
      });
      return;
    }
    setSelectedFilter({ filterName: item, field: "", fieldValue: "" });
  };

  const fetchReportStatus = () => {
    crmReportStatus(currentBrand?.brand_id).then((res) => {
      if (res?.status === 200) {
        const report = res?.data?.crm_report
        report ? setReportStatus(report?.user_seen) : setReportStatus(true)
        if (report?.status === 10) {

          setToastState({
            show: true,
            message: "Report has been sent to your email, successfully",
            type: "Success",
            duration: 3000
          });

          const payload = { crm_report_id: report?.id };
          crmReportUserSeen(currentBrand?.brand_id, payload).then((res) => {
            if (res?.status === 200) {
            }
          });
        }else if(report?.status === -1){
          setToastState({
            show: true,
            message: "Report has not been sent due to an error, please try again",
            type: "Error",
            duration: 3000
          });

          const payload = { crm_report_id: report?.id };
          crmReportUserSeen(currentBrand?.brand_id, payload).then((res) => {
            if (res?.status === 200) {
            }
          });
        }else if(report?.status === 0 || report?.status === 3 || report?.status === 5){
        }
      }
    });
  };

  // // useEffect for report status
  // useEffect(() => {
  //   let interval;
  //   let timeout;

  //   fetchReportStatus();
  //   interval = setInterval(fetchReportStatus, 5000);

  //   return () => {
  //     clearInterval(interval);
  //     clearTimeout(timeout);
  //   };
  // }, [currentBrand]);

  const brandId = currentBrand?.brand_id;
  // generate report function
  // const generateReport = async () => {
  //   try {
  //     if (brandId) {
  //       const selectedIds = selectedItems.filter(i => i.selected).map(i => i.id);
  //       const deselectedIds = selectedItems.filter(i => !i.selected).map(i => i.id);

  //       // Check if either select all is true or at least one contact is selected
  //       if (!selectAll && selectedIds.length === 0) {
  //         setToastState({
  //           show: true,
  //           message: "Please select at least one contact or enable select all",
  //           type: "Error",
  //           duration: 2000
  //         });
  //         return;
  //       }

  //       const queryParams = {
  //         limit: crmCount,
  //         page: 1,
  //         search: crmSearch,
  //         filters: Object.keys(filters)?.length > 0 ? filters : undefined,
  //         send_report: true,
  //         tag_id: activeFilter?.tag ? activeFilter?.id : undefined,
  //         user_id: activeFilter?.user_name ? activeFilter?.id : undefined,
  //         contact_origin: activeFilter?.name ? activeFilter?.name : undefined,
  //         select_all: selectAll,
  //         contact_person_ids: selectAll ? deselectedIds : selectedIds,
  //       }
  //       const res = await crmListShow(brandId, queryParams)
  //       if (res?.status === 200) {
  //         setToastState({
  //           show: true,
  //           message: "Report has been sent to your email, shortly",
  //           type: "Success",
  //           duration: 3000
  //         });
  //       }
  //     }
  //   } catch (error) {
  //     console.error("Error fetching crm contacts:", error);
  //   }
  // }

  // Check if we're viewing an audience set
  const isAudienceSet = activeFilter?.type === 'audience_set';

  const renderFilterModal = () => (
    <Modal
      open={active}
      styles={{ content: { padding: 0 } }}
      onOpenChange={handleClick}
      rootclassName="max-w-[35vw] crm-dropdown rounded-2xl overflow-hidden"
      Button={
        <div className="flex items-center cursor-pointer whitespace-nowrap py-[.2vw] rounded-md">
          <AddIcon stroke="var(--textBlack)" width="24" height="24" />
          <span className="text-[.8vw] font-[500]">Add Filter</span>
        </div>
      }
      sideBarMainClassName="p-[0vw_!important]"
      ModelSideNav={
        <div className="space-y-[1vw] max-h-[50vh] overflow-scroll scroll_visible *:w-[8vw] *:py-[.4vw] text-[.75vw] *:ps-[.5vw] px-[.8vw] py-[1vw]">
          {filterKeys.map(({ name: filterName }) => (
            <p
              key={filterName}
              className={`w-full ${
                selectedFilter.filterName === filterName
                  ? `bg-[${primaryColor}] text-white`
                  : "hover:bg-gray-200"
              } rounded-md capitalize cursor-pointer duration-200`}
              onClick={() => handleChangeFilter(filterName)}
            >
              {convertName(filterName)}
            </p>
          ))}
        </div>
      }
    >
      <div className="grid grid-rows-[6fr,1fr] h-full scroll_visible">
        <div className="space-y-[.5vw] max-h-[43vh] overflow-scroll scroll_visible *:w-[5vw]- px-[1vw] pt-[1vw]">
          {Object.entries(mainFilters?.[selectedFilter?.filterName]?.filters || {}).map(([filterKey]) => {
            const props = mainFilters?.[selectedFilter?.filterName].props;
            const isOnlyCheckBox = props.check.includes(filterKey);
            return (
              <FilterModelContent
                key={filterKey}
                filterKey={filterKey}
                type={props?.type}
                tagList={tagList}
                inputType={props?.inputType}
                propsData={props?.data}
                onlySelectFields={props?.check}
                isOnlyCheckBox={isOnlyCheckBox}
                selectedFilter={selectedFilter}
                setSelectedFilter={setSelectedFilter}
              />
            );
          })}
        </div>
        <div className="flex justify-end sticky bottom-0 bg-white gap-[.5vw] w-full border-t border-t-gray-200 py-[.5vw] pe-[1vw]">
          <Button
            onClick={handleClick}
            label="Cancel"
            classNames="text-black"
            color="white"
          />
          <Button
            disabled={!selectedFilter.fieldValue || selectedFilter.fieldValue.length === 0}
            onClick={() => {
              if (!selectedFilter.fieldValue && selectedFilter.fieldValue.length === 0) {
                return;
              }
              setActive(false);
              setOperator(prev => ({ ...prev, operator: "and" }));
              setSelectedFilter({
                filterName: "name",
                field: "",
                fieldValue: "",
              });
              dispatch(
                setFilters({
                  key: selectedFilter.filterName,
                  filter: { [selectedFilter.field]: selectedFilter.fieldValue },
                  value: {
                    selectedFilter: selectedFilter.filterName,
                    selectedField: selectedFilter.field,
                    fieldValue: selectedFilter.fieldValue,
                  },
                  operator: operator.operator,
                })
              );
            }}
            label="Apply"
            classNames="text-[.5]"
          />
        </div>
      </div>
    </Modal>
  );

  return (
    <>
      {/* Toast for report status */}
      {toastState.show && (
        <div className="fixed top-4 right-4 z-50">
          <ToastMain
            key={Date.now()}
            message={toastState.message}
            type={toastState.type}
            handleClick={() => setToastState(prev => ({ ...prev, show: false }))}
          />
        </div>
      )}

      <div className="mx-[1vw] border-b border-b-[var(--border-50)] py-4">
        <div className="flex items-center justify-between w-full">
          <div className="flex-1 flex items-center gap-4">
            {isAudienceSet ? (
              // Show audience set filters in read-only mode
              <div className="flex-1">
                <AudienceSetFiltersView filters={activeFilter?.filters} />
              </div>
            ) : (
              // Show regular filters with add/remove functionality
              <div className="flex-1 flex items-center justify-between">
                <div className="flex items-center gap-2">
                  {filters.length > 0 && (
                    <RenderFilters
                      filters={filters || []}
                      operator={operator}
                      setOperator={setOperator}
                      handleAddNewFilter={handleClick}
                    />
                  )}
                  {renderFilterModal()}
                </div>
                {/* Download Reports Button */}
                {/* <div
                  className={`group p-5 flex-row align-center h-fit ${!reportStatus ? 'cursor-not-allowed' : 'pointer hover:bg-[var(--new-primary-bg)]'} b-radius-6 border border-[var(--border-input)] text-[1rem] font-[500] text-[var(--font-600)] hover:text-[var(--new-primary)] hover:border-[var(--new-primary-bg)]`}
                  onClick={() => {
                    if (reportStatus) {
                      generateReport();
                    }
                  }}
                >
                  <Tooltip title={!reportStatus ? "Report is generating, please wait" : "Download Reports"} placement="bottom">
                    <div className={`flex items-center ${!reportStatus ? 'cursor-not-allowed' : 'cursor-pointer'}`}>
                      <Download
                        className="stroke-[var(--font-600)] group-hover:stroke-[var(--new-primary)] h-[20px] w-[20px]"
                        color=""
                      />
                    </div>
                  </Tooltip>
                </div> */}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
